module.exports = __webpack_public_path__ + "img/t2-4.2ea876de.svg";